import _ from "lodash";
import React, { useState } from "react";
import { createUseStyles } from "react-jss";
import {
  genericIndexesStyles,
  btnStyles,
  tableStyles,
  variables,
} from "../../../../variables";
import Navbar from "./Navbar";
import ControlStrip from "../../../../components/ControlStrip";
import Loader from "../../../../components/Loader";
import {
  handleApplyFilters,
  medWeekdayDatetimer,
  shortDater,
} from "../../../../helpers";
import DetailCoordinatorModal from "../CoordinatorsModals/DetailCoordinatorModal";
import {
  fetchCoordinatorReservations,
  getCoordinatorReservationStats,
} from "../../../../api/CRS/Coordinator";
import ReservationStats from "../../CommonCRSModals/ReservationStats/ReservationStats";
import { commonTableHeaders } from "../../helpers";
import { useQueries } from "@tanstack/react-query";
import HamburgerMenu from "../../../../components/HamburgerMenu";
import { genericRequestErrorHandler } from "../../../../api";
import { useListPageSidebar } from "../../../../hooks";
import * as yup from "yup";
import { DateTime } from "luxon";
import { CustomButton } from "../../../../components/CustomButton";

const initialFilters = {
  limit: 20,
  page: 1,
  ordering: "",
  discending: "",
  name: "",
  status: "",
  travel_start_date__gte: "",
  travel_end_date__lte: "",
  created__gte: "",
  created__lte: "",
  external_reference__icontains: "",
  source_entity: "",
  network_search: "",
  market_type: "",
  reference: "",
};
const navbarSchema = yup.object().shape({
  name: yup
    .string()
    .min(2, "Name must be more than 1 characters")
    .max(100, "Name: Must be less than 100 characters"),
  created__gte: yup.date(),
  created__lte: yup.date().max(new Date(), "Date cannot be in the future"),
});

const coordinatorsStyles = createUseStyles({
  Coordinator: {
    ...genericIndexesStyles.indexes.mobile(),
    gridTemplateRows: "auto auto auto  1fr",
  },
  tableContainer: genericIndexesStyles.tableContainer.mobile(),
  table: tableStyles.table,
  headRow: tableStyles.head.row,
  headCell: tableStyles.head.cell,
  bodyRow: tableStyles.body.row,
  tablecell: tableStyles.body.cell,
  actionCell: {
    ...tableStyles.body.cell,
    gap: variables.half_gap,
  },
  nameCell: { ...tableStyles.body.cell, width: "13rem", minWidth: "13rem" },
  datesCell: { ...tableStyles.body.cell, width: "9rem", minWidth: "9rem" },
  travelCell: { ...tableStyles.body.cell, width: "6rem", minWidth: "6rem" },
  marketTypeCell: { ...tableStyles.body.cell, width: "3rem" },
  originalServiceCell: { ...tableStyles.body.cell, width: "8rem" },
  referenceCell: { ...tableStyles.body.cell, width: "5rem" },
  statusCell: { ...tableStyles.body.cell, width: "12rem" },
  btn: btnStyles.btn,
  [`@media ${variables.media.smallscreen}`]: {
    tableCell: {
      padding: `calc(${variables.normal_gap} * 2.5) 0`,
    },
  },
});
const Coordinators = () => {
  const classes = coordinatorsStyles();

  useListPageSidebar();

  const [filters, setFilters] = useState(initialFilters);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [reference, setReference] = useState(null);

  const tableHeaders = commonTableHeaders({
    Name: (val) => val.name,
    Tags: (val) => _.get(val, "tags", []).join(","),
    "Travel Start": (val) => val.travel_start_date,
    "Travel End": (val) => val.travel_end_date,
    Supplier: (val) => val.supplier_name,
    "Payment Mode": (val) => val.payment_mode_display,
    "Market Type": (val) => val.market_type,
  });
  const handleApplyLocalFilters = (filters) => {
    handleApplyFilters(filters, setFilters, navbarSchema);
  };
  const results = useQueries({
    queries: [
      {
        queryKey: ["coordinators", filters],
        queryFn: async () => {
          let correctPayload = { ...filters };
          if (filters.created__lte) {
            correctPayload["created__lte"] = DateTime.fromISO(
              filters.created__lte
            ).toISO();
          }
          if (filters.created__gte) {
            correctPayload["created__gte"] = DateTime.fromISO(
              filters.created__gte
            ).toISO();
          }
          if (filters.travel_start_date__gte) {
            correctPayload["travel_start_date__gte"] = DateTime.fromISO(
              filters.travel_start_date__gte
            ).toISO();
          }
          if (filters.travel_end_date__lte) {
            correctPayload["travel_end_date__lte"] = DateTime.fromISO(
              filters.travel_end_date__lte
            ).toISO();
          }
          return await fetchCoordinatorReservations({
            params: correctPayload,
          });
        },
        enabled: !showDetailModal,
        onError: (error) => genericRequestErrorHandler(error),
      },
      {
        queryKey: ["coordinatorsStats", filters],
        queryFn: async () => {
          let correctPayload = { ...filters };
          if (filters.created__lte) {
            correctPayload["created__lte"] = DateTime.fromISO(
              filters.created__lte
            ).toISO();
          }
          if (filters.created__gte) {
            correctPayload["created__gte"] = DateTime.fromISO(
              filters.created__gte
            ).toISO();
          }
          if (filters.travel_start_date__gte) {
            correctPayload["travel_start_date__gte"] = DateTime.fromISO(
              filters.created__gte
            ).toISO();
          }
          if (filters.travel_end_date__lte) {
            correctPayload["travel_end_date__lte"] = DateTime.fromISO(
              filters.created__gte
            ).toISO();
          }
          return await getCoordinatorReservationStats({
            params: correctPayload,
          });
        },
        enabled: !showDetailModal,
      },
    ],
  });

  return (
    <div id="COOListPage" className={classes.Coordinator}>
      <Navbar
        filters={filters}
        initialFilters={initialFilters}
        onApplyFilters={handleApplyLocalFilters}
      />
      <HamburgerMenu />
      {!_.get(results, "1.isLoading", true) &&
        _.get(results, "1.data", null) && (
          <ReservationStats
            title="Reservation Stats"
            stats={_.get(results, "1.data.data.stats_per_currency")}
          />
        )}
      <ControlStrip
        limit={_.get(filters, "limit")}
        page={filters.page}
        count={_.get(results, "0.data.data.count")}
        onChangeLimit={(limit) => setFilters({ ...filters, limit, page: 1 })}
        onChangePage={(page) => setFilters({ ...filters, page })}
        orderOptions={[["created", "Created"]]}
        onChangeOrderOptions={(ordering) =>
          setFilters({ ...filters, ordering })
        }
      />
      {_.get(results, "0.isLoading", false) ? (
        <Loader />
      ) : (
        <div className={classes.tableContainer}>
          <table className={classes.table}>
            <thead className={classes.thead}>
              <tr className={classes.headRow}>
                <th className={classes.headCell}>#</th>
                {Object.keys(tableHeaders).map((value, idx) => (
                  <th className={classes.headCell} key={idx}>
                    {value}
                  </th>
                ))}
                <th className={classes.headCell}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {_.get(results, "0.data.data.results", []).map((val, idx) => (
                <tr className={classes.bodyRow} key={idx}>
                  <td className={classes.tablecell}>{idx + 1}</td>
                  {Object.entries(tableHeaders).map((entry, ridx) => {
                    var cell = null;
                    const fn = entry[1];
                    switch (entry[0].toLowerCase()) {
                      case "name":
                        cell = fn(val) || "N/A";
                        return (
                          <td className={classes.nameCell} key={ridx}>
                            {cell}
                          </td>
                        );
                      case "status / booking mode":
                        cell = fn(val) || "N/A";
                        return (
                          <td className={classes.statusCell} key={ridx}>
                            {cell}
                          </td>
                        );
                      case "reference":
                        cell = fn(val) || "N/A";
                        return (
                          <td className={classes.referenceCell} key={ridx}>
                            {cell}
                          </td>
                        );
                      case "original service price":
                        cell = fn(val) || "N/A";
                        return (
                          <td
                            className={classes.originalServiceCell}
                            key={ridx}>
                            {cell}
                          </td>
                        );
                      case "market type":
                        cell = fn(val) || "N/A";
                        return (
                          <td className={classes.marketTypeCell} key={ridx}>
                            {cell}
                          </td>
                        );
                      case "travel end":
                        cell = fn(val) ? shortDater(fn(val)) : "N/A";
                        return (
                          <td className={classes.travelCell} key={ridx}>
                            {cell}
                          </td>
                        );
                      case "travel start":
                        cell = fn(val) ? shortDater(fn(val)) : "N/A";
                        return (
                          <td className={classes.travelCell} key={ridx}>
                            {cell}
                          </td>
                        );
                      case "created":
                        cell = fn(val) ? medWeekdayDatetimer(fn(val)) : "N/A";
                        return (
                          <td className={classes.datesCell} key={ridx}>
                            {cell}
                          </td>
                        );
                      default:
                        cell = fn(val) || "N/A";
                        break;
                    }
                    return (
                      <td className={classes.tablecell} key={ridx}>
                        {cell}
                      </td>
                    );
                  })}
                  <td className={classes.actionCell}>
                    <CustomButton
                      id={`detailCOOButton_${idx}`}
                      appearance="ghost"
                      onClick={() => {
                        setReference(val.reference);
                        setShowDetailModal(true);
                      }}>
                      <strong>Details</strong>
                    </CustomButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {showDetailModal && (
        <DetailCoordinatorModal
          onClose={() => setShowDetailModal(false)}
          reference={reference}
        />
      )}
    </div>
  );
};

export default Coordinators;
